import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsLetterPressSkin = {
  ...textEffectsSharedSkin,
  'shadow-angle': {
    type: 'CSSString',
    defaultValue: '225deg',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: '7',
  },
  'shadow-distance': {
    type: 'NUMBER',
    defaultValue: '5',
  },
  'layer-blend-mode': {
    type: 'CSSString',
    defaultValue: 'normal',
  },
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-opacity-color-1': {
    type: 'NUMBER',
    defaultValue: '1',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#151515',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsLetterPressSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsLetterPress': TextEffectsLetterPressSkin,
};

export default generateSkinDefaults(TextEffectsLetterPressSkinDefinitionMap);
